var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.22 0 22.44 0 34 0 C34 13.86 34 27.72 34 42 C29.05 42 24.1 42 19 42 C19 41.34 19 40.68 19 40 C23.29 40 27.58 40 32 40 C32 27.46 32 14.92 32 2 C22.1 2 12.2 2 2 2 C2 14.54 2 27.08 2 40 C3.65 40 5.3 40 7 40 C7 40.66 7 41.32 7 42 C4.69 42 2.38 42 0 42 C0 28.14 0 14.28 0 0 Z ",
    fill: "#949494",
    transform: "translate(8,4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.18529142 4.29773979 1.97797551 7.12113467 1.125 11.8125 C0.92132813 12.97394531 0.71765625 14.13539062 0.5078125 15.33203125 C0.25644531 16.65267578 0.25644531 16.65267578 0 18 C-0.9075 17.814375 -1.815 17.62875 -2.75 17.4375 C-5.68314324 17.04265379 -7.2644657 17.05308428 -10 18 C-10.39058179 15.75265248 -10.76192958 13.50195579 -11.125 11.25 C-11.33382813 9.99703125 -11.54265625 8.7440625 -11.7578125 7.453125 C-11.99511384 4.06966715 -12.04747557 2.65270419 -10 0 C-6.30581799 -1.231394 -3.7943739 -0.64432764 0 0 Z M-6 2 C-6.66 2.66 -7.32 3.32 -8 4 C-8 4.99 -8 5.98 -8 7 C-4.95086772 8.01111093 -4.95086772 8.01111093 -2 7 C-2.26676204 5.01508358 -2.26676204 5.01508358 -3 3 C-3.99 2.67 -4.98 2.34 -6 2 Z M-8 11 C-7.67 11.99 -7.34 12.98 -7 14 C-5.35 14 -3.7 14 -2 14 C-2 13.01 -2 12.02 -2 11 C-3.98 11 -5.96 11 -8 11 Z ",
    fill: "#959595",
    transform: "translate(26,31)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.66 20 1.32 20 2 C13.4 2 6.8 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#959595",
    transform: "translate(15,22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.66 20 1.32 20 2 C13.4 2 6.8 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#959595",
    transform: "translate(15,16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.e3b03ade99c782504f24b775babf3518.svg";
export { ForwardRef as ReactComponent };